import { useEffect, useRef } from 'react';

export function useScrollAnimation() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const targets = entry.target.querySelectorAll('.fade-in-up');
            targets.forEach((target) => {
              target.classList.add('visible');
            });
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    const items = element.querySelectorAll('.fade-in-up');
    items.forEach((item) => observer.observe(item));
    if (element.classList.contains('fade-in-up')) {
      observer.observe(element);
    }

    return () => observer.disconnect();
  }, []);

  return ref;
}

export function useScrollAnimationSection() {
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    const section = ref.current;
    if (!section) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const targets = entry.target.querySelectorAll('.fade-in-up');
            targets.forEach((target, index) => {
              setTimeout(() => {
                target.classList.add('visible');
              }, index * 100);
            });
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
    );

    observer.observe(section);

    return () => observer.disconnect();
  }, []);

  return ref;
}
